import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

const DurationFormatter = (props) => {
  if (!props.dependentValues.rowData) return <div />;
  const divStyle = { textAlign: 'left' };

  let value = props.value ? props.value : '';

  if (value !== '') {
    const duration = moment.duration(value);
    if (duration) {
      value = duration.humanize();
    }
  }

  return (
    <div className="" style={divStyle} title={value}>
      {value}
    </div>
  );
};

DurationFormatter.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default DurationFormatter;
